import { render, staticRenderFns } from "./etablissement-detail-export-paye.vue?vue&type=template&id=2291a27c"
import script from "./etablissement-detail-export-paye.vue?vue&type=script&lang=js"
export * from "./etablissement-detail-export-paye.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports